import { render } from "./InformInfoForm.vue?vue&type=template&id=3907e75b"
import script from "./InformInfoForm.vue?vue&type=script&lang=js"
export * from "./InformInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__